export default {"src":"/login-app/[GIT_HASH]/_next/static/media/changes_present.f2ca4d93.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};